import { render, staticRenderFns } from "./DossierBourse.vue?vue&type=template&id=55cefad2"
import script from "./DossierBourse.vue?vue&type=script&lang=js"
export * from "./DossierBourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports